import { render, staticRenderFns } from "./AdminStats.vue?vue&type=template&id=17a869bb&scoped=true&"
import script from "./AdminStats.vue?vue&type=script&lang=ts&"
export * from "./AdminStats.vue?vue&type=script&lang=ts&"
import style0 from "./AdminStats.vue?vue&type=style&index=0&id=17a869bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a869bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VBtn,VChip,VChipGroup})
